"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  getSessionStore: function getSessionStore(key) {
    var sessionObj = window.sessionStorage.getItem(key);
    var accessTime = Date.now();
    if (sessionObj && sessionObj !== 'null') {
      sessionObj = JSON.parse(sessionObj);
      var _sessionObj = sessionObj,
        timeout = _sessionObj.timeout,
        storedTime = _sessionObj.storedTime;
      // update outdated flag only
      sessionObj.outdated = Boolean(accessTime - Number(storedTime) >= timeout);
      window.sessionStorage.setItem(key, JSON.stringify(sessionObj));
    } else {
      // remove item if value is not present
      window.sessionStorage.removeItem(key);
      sessionObj = null;
    }
    return sessionObj;
  },
  setSessionStore: function setSessionStore(key, data) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;
    var outdated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var value = {
      data: data,
      storedTime: Date.now(),
      // read timeout in minutes and store in milliseconds
      timeout: timeout * 60000,
      outdated: outdated
    };
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(e);
    }
  }
};
exports.default = _default;